import { CssBaseline } from "@mui/material";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import NewRouting from "./components/Nav&Rout/NewRouting";
import { store, persistor } from "./store/store";

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastContainer />
        <CssBaseline />
        <React.StrictMode>
          <Router>
            <NewRouting />
          </Router>
        </React.StrictMode>
      </PersistGate>
    </Provider>
  );
}

export default App;
